import {
  BotAppearanceStep,
  BotIntelligenceStep,
} from "./components/CustomSteps";
import TrainBotStep from "./components/TrainBotStep";
import type { OnboardingStep } from "./types";

export const steps: OnboardingStep[] = [
  {
    id: 1,
    title: "Let's create your AI agent",
    description: "Give your agent a name. You can always change it later.",
    field: {
      name: "agentName",
      label: "Agent name",
      placeholder: "e.g. Nova, Support Assistant, Sales Copilot",
      required: true,
      type: "text",
    },
    actions: [{ id: "continue", label: "Continue", variant: "primary" }],
  },
  {
    id: 2,
    title: "Train your AI Agent",
    description:
      "Add knowledge using your website, files, text, or connected apps to make your agent even smarter.",
    Component: TrainBotStep,
    actions: [
      { id: "back", label: "Back", variant: "secondary" },
      {
        id: "customizeAppearance",
        label: "Design Your Widget",
        variant: "primary",
      },
    ],
  },
  {
    id: 3,
    title: "Customize Your Agent",
    description:
      "We've matched your website's branding. Review and customize your agent's appearance.",
    Component: BotAppearanceStep,
    actions: [
      { id: "back", label: "Back", variant: "secondary" },
      { id: "continue", label: "Continue", variant: "primary" },
    ],
  },
  {
    id: 4,
    title: "Define Agent Intelligence",
    description: "Choose how smart and how personable your agent should be.",
    Component: BotIntelligenceStep,
    actions: [
      { id: "back", label: "Back", variant: "secondary" },
      { id: "finishSetup", label: "Finish setup", variant: "primary" },
    ],
  },
];
